export default __webpack_public_path__ + "static/icon-logo-act-8da4f01e5bf1a505cb64334eb216ddda.png";